import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Button } from "semantic-ui-react";

import SegmentMessage from "../forms/messages/SegmentMessage.jsx";
import LinkWithReset from "../utils/LinkWithReset.jsx";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class UserDetailsRequestFormResult extends PureComponent {
  static propTypes = {
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  // -- RENDER -- //

  render() {
    const { copyKey, copy } = this.props;

    return (
      <Fragment>
        <SegmentMessage title={copy(`${copyKey}.title`)} positive={true} />

        <p>{copy(`${copyKey}.message`)}</p>

        <Button as={LinkWithReset} to="/" size="large" primary fluid>
          {copy(`${copyKey}.login_cta`)}
        </Button>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(UserDetailsRequestFormResult);
